export const tw = (classNames: TemplateStringsArray) => `${classNames}`;
